import React from "react";
import "./Loginheader.css";
import logo from "../../assests/BEMSS1.png";

export default function Loginheader() {

    const isMobile = window.innerWidth < 768;
    return (
        <header className="loginheader">
            {
                isMobile ? (
                    <img src={logo} style={{ width: '150px', height: '40px' }} alt="App Logo" className="logo" />
                ) :
                    (
                        <img style={{ width: '150px' }} src={logo} alt="App Logo" className="logo" />
                    )
            }
        </header>
    );
}
